import { render, staticRenderFns } from "./NoteSubfolderAttrEdit.vue?vue&type=template&id=0df6478c&"
import script from "./NoteSubfolderAttrEdit.vue?vue&type=script&lang=js&"
export * from "./NoteSubfolderAttrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports